import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  FormArray,
} from '@angular/forms';

/**
 * Check that the first date is after before the second date (ignore time)
 * @param control
 * @returns null if valid or an error object
 */
export function dateOrderValidator(
  firstDateControlName: string,
  secondDateControlName: string
): ValidatorFn {

  return (control: AbstractControl): ValidationErrors | null => {
    const firstDate = control.get(firstDateControlName)?.value;
    const secondDate = control.get(secondDateControlName)?.value;

    if (!firstDate || !secondDate) {
      return null;
    }

    const firstDateObj = new Date(firstDate);
    const secondDateObj = new Date(secondDate);

    if (secondDateObj <= firstDateObj) {
      return { invalidDateRange: true };
    }

    return null;
  };
}

export const isDateValidValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  if (!control.value) {
    return null; // Le validateur `required` s'en charge
  }

  const dateValue = new Date(control.value);
  if (isNaN(dateValue.getTime())) {
    return { invalidDate: true };
  }

  return null;
};
